import { SessionData } from './Reducer'

export const EMPTY_SESSION: SessionData = {
  isOverridden: false,
  name: '',
  sequence: '',
  fiveMod: '',
  purification: '',
  baseCount: 0,
  format: '',
  concentration: '',
  tubes: '1',
  price: '',
  scale: '',
  orderItemId: '',
  id: '1',
  comments: '',
  additionalComments: '',
  oligoId: 1,
  countryCode: '',

  autoValidation: 'false',
  productType: '',
  customerOverhang: '',
  antisenceName: '',
  antisenceSequence: '',
  autoGenerateOligo: false,
  customerAntisenseOverHang: '',
  antisenceBaseCount: 0,
  amount: '',
  senseNameCheck: false,
  listError: [{ key: '', value: '' }],
}

export const EMPTY_REVIEW_OBJ: SessionData = {
  isOverridden: false,
  name: '',
  sequence: '',
  fiveMod: '',
  purification: '',
  baseCount: 0,
  format: '',
  concentration: '',
  tubes: '1',
  price: '',
  scale: '',
  orderItemId: '',
  id: '1',
  comments: '',

  additionalComments: '',
  oligoId: 1,
  countryCode: '',
  autoValidation: 'false',
  productType: '',
  customerOverhang: '',
  antisenceName: '',
  antisenceSequence: '',
  autoGenerateOligo: false,
  customerAntisenseOverHang: '',
  antisenceBaseCount: 0,
  amount: '',
  senseNameCheck: false,
  listError: [{ key: '', value: '' }],
}

export const EMPTY_OBJECT: SessionData = {
  isOverridden: false,
  name: '',
  sequence: '',
  fiveMod: '',
  purification: '',
  baseCount: 0,
  format: '',
  concentration: '',
  tubes: '1',
  price: '',
  scale: '',
  orderItemId: '',
  id: '1',
  comments: '',
  additionalComments: '',
  oligoId: 1,
  countryCode: '',
  autoValidation: 'false',

  productType: '',
  customerOverhang: '',
  antisenceName: '',
  antisenceSequence: '',
  autoGenerateOligo: false,
  customerAntisenseOverHang: '',
  antisenceBaseCount: 0,
  amount: '',
  senseNameCheck: false,
  listError: [{ key: '', value: '' }],
}
